import styles from './Input.module.css';
import { Icon } from '../index';
import { Icons } from '../Icon/Icon';

const InputLabel = ({
    children,
    label,
    info,
    fullWidth = true,
    extended,
    labelFullWidth,
    align,
    required,
    isActive,
    isTitleActive,
    style,
    max,
    valueLength,
    afterLabel,
    disabled,
    labelStyles,
    afterInput,
    margin = true,
    forceMargin = false,
    labelWidth,
}: any) => {
    const TagName = `${afterLabel || info ? 'div' : 'label'}`;
    const SubTagName = `${afterLabel || info ? 'label' : 'div'}`;

    return (
        <>
            {/* @ts-ignore */}
            <TagName
                className={`${styles.container} 
            ${(!!label && margin) || forceMargin ? styles.offset : ''} 
            ${isActive ? styles.active : ''} 
            ${isTitleActive ? styles.activeTitle : ''}
            ${!!info ? styles.hasInfo : ''}
            ${extended ? styles.extended : ''}
            ${align ? styles[`align-${align}`] : ''}
            ${fullWidth ? styles.fullWidth : ''}
            ${style === 'text' ? styles.textStyle : ''}
            ${style === 'textPreview' ? styles.textPreview : ''}
            ${style === 'secondary' ? styles.secondary : ''}
            ${style === 'small' ? styles.small : ''}
            `}
                style={labelStyles}
            >
                {!!label && (
                    <span
                        className={`${styles.label}
                            ${labelFullWidth ? styles.labelFullWidth : ''}
                            ${labelWidth ? styles[`label-${labelWidth}`] : ''}
                            `}
                    >
                        <span className={`${styles.labelInner}`}>
                            {label}

                            {!!afterLabel && <span className={styles.afterLabel}>{afterLabel || ''}</span>}
                        </span>
                    </span>
                )}

                {!!children && (
                    <>
                        {/* @ts-ignore */}
                        <SubTagName className={styles.inputWrapper}>
                            {children}

                            {(style === 'text' || style === 'textPreview') && (
                                <>
                                    <span
                                        className={`${styles.icon} ${style === 'textPreview' ? styles.iconRight : ''}`}
                                    >
                                        <Icon icon={Icons.pen} />
                                    </span>

                                    {(style === 'textPreview' || (style === 'text' && !disabled)) && (
                                        <span className={styles.bg}></span>
                                    )}
                                </>
                            )}

                            {afterInput && children && <div className={styles.afterInput}>{afterInput}</div>}
                        </SubTagName>
                    </>
                )}

                {!!info && <p>{info}</p>}

                {required && !max && <span className={styles.note}>*required</span>}

                {!!max && (
                    <span className={styles.max}>
                        <span>Characters</span>
                        <span>
                            {valueLength} / {max}
                        </span>
                    </span>
                )}
            </TagName>
        </>
    );
};

export default InputLabel;
